// Static sample data for Kepelatihan (Training)
// Exports: trainingHistory, trainingCatalog, vendors, curricula

export const vendors = [
  { id: 'v1', name: 'PT. Pelatihan Prima', contact: 'training@prima.co.id', phone: '021-555-0101' },
  { id: 'v2', name: 'CV. Mitra Edukasi', contact: 'info@mitraedukasi.id', phone: '021-555-0202' },
  { id: 'v3', name: 'Academy Nusantara', contact: 'academy@nusantara.ac', phone: '021-555-0303' }
];

export const trainingCatalog = [
  { id: 't1', title: 'Leadership Essentials', vendor_id: 'v1', duration_days: 2, category: 'Leadership', price_idr: 2500000 },
  { id: 't2', title: 'Effective Communication', vendor_id: 'v2', duration_days: 1, category: 'Soft Skills', price_idr: 900000 },
  { id: 't3', title: 'Advanced Excel for Analysts', vendor_id: 'v3', duration_days: 2, category: 'Technical', price_idr: 1200000 },
  { id: 't4', title: 'Occupational Safety (K3)', vendor_id: 'v1', duration_days: 1, category: 'Compliance', price_idr: 800000 }
];

// Curricula: modules for trainings (linked by training id)
export const curricula = [
  { id: 'c1', training_id: 't1', module: 'Introduction to Leadership', duration_minutes: 90 },
  { id: 'c2', training_id: 't1', module: 'Situational Leadership', duration_minutes: 120 },
  { id: 'c3', training_id: 't1', module: 'Feedback & Coaching', duration_minutes: 90 },

  { id: 'c4', training_id: 't2', module: 'Active Listening', duration_minutes: 60 },
  { id: 'c5', training_id: 't2', module: 'Non-verbal Communication', duration_minutes: 45 },

  { id: 'c6', training_id: 't3', module: 'Data Cleaning and Tables', duration_minutes: 90 },
  { id: 'c7', training_id: 't3', module: 'Pivot Tables & Charts', duration_minutes: 120 },
  { id: 'c8', training_id: 't3', module: 'Advanced Formulas', duration_minutes: 90 },

  { id: 'c9', training_id: 't4', module: 'K3 Basics', duration_minutes: 60 },
  { id: 'c10', training_id: 't4', module: 'Emergency Response', duration_minutes: 60 }
];

// Training history per employee (sample)
export const trainingHistory = [
  {
    emp_id: 'P3101',
    full_name: 'Samuel Sukarno',
    trainings: [
      { training_id: 't2', title: 'Effective Communication', vendor_id: 'v2', date_taken: '2024-09-15', status: 'completed', certificate: null },
      { training_id: 't3', title: 'Advanced Excel for Analysts', vendor_id: 'v3', date_taken: '2025-01-10', status: 'registered', certificate: null }
    ]
  },
  {
    emp_id: 'P0740',
    full_name: 'Viko RICO',
    trainings: [
      { training_id: 't1', title: 'Leadership Essentials', vendor_id: 'v1', date_taken: '2024-11-20', status: 'completed', certificate: 'https://example.com/certs/viko-leadership.pdf' }
    ]
  }
];

export default {
  vendors,
  trainingCatalog,
  curricula,
  trainingHistory
};
